import React, { useEffect, useState } from 'react';
import "./inputicon.scss";
import search from '../../assets/svg/ic-actions-searchReverse.svg';
import IconView from '../../assets/svg/ic-actions-view.svg';
import IconCloseView from '../../assets/svg/ic-actions-closed-view.svg';
import { Link } from 'react-router-dom';


// theme={2}
// label="Nome do usuário"
// icon={}

const InputIcon = ({
    placeholder,
    value,
    onChange,
    onKeyUp,
    theme,
    label,
    icon,
    opcional,
    children,
    style,
    type = "text",
    onKeyPress,
    id,
    disabled,
    ref,
    required = false,
    autoCompleteProps
}) => {
    const [typeState, setTypeState] = useState(type);

    useEffect(() => {
        setTypeState(type);
    }, [type]);

    const renderStyle = () => {
        let stl = "gb-cont-input-icon";
        if (theme) {
            if (theme == 2)
                stl = stl + " gb-cont-input-theme2";
        }

        return stl;
    }

    const setPasswordVisible = () => {
        setTypeState(typeState === 'password' ? 'text' : 'password');
    }

    const renderInput = () => {
        return (
            <div className={renderStyle()} style={style || null}>
                <div className="gb-input-icon">
                    {icon && typeof icon === 'string' && icon.indexOf('/') < 0 ? (<i className={icon} />) : (
                        <img src={icon ? icon : search} width="20" height="20" />)}
                </div>
                {children ? children :
                    <input
                        ref={ref}
                        disabled={disabled}
                        id={id ? id : 'no_id'}
                        type={typeState}
                        className="form-control gb-input"
                        placeholder={placeholder}
                        value={value || ''}
                        onChange={(e) =>
                            onChange(e.target.value)}
                        required={required}
                        {...autoCompleteProps}
                    />
                }
                {/* onKeyUp={(evt) => onKeyUp(evt.target.value)} */}
                {type === 'password' ? (
                    <Link className="gb-input-icon" onClick={setPasswordVisible}>
                        <img src={typeState == 'password' ? IconView : IconCloseView} height={15} />
                    </Link>

                ) : null}
            </div>
        );
    }

    const renderInputWithLabel = () => {
        return (
            <div>
                <label className="gb-input-label">{label}{opcional ? <span style={{ opacity: 0.46, fontStyle: 'italic', fontSize: 14 }}> - Opcional</span> : ''}</label>
                {renderInput()}
            </div>
        )
    }

    const renderAll = () => {
        if (theme) {
            if (theme == 2)
                return renderInputWithLabel();
            else return renderInput();
        } else return renderInput();
    }

    return (
        <>
            {renderAll()}
        </>
    )

}

export default InputIcon;